import { Clock, CheckCircle, Minus } from 'lucide-react';

interface StatusIconProps {
  status: 'pending' | 'matched' | 'ignored' | null | undefined;
}

export function StatusIcon({ status }: StatusIconProps) {
  // Treat null/undefined as pending
  const actualStatus = status || 'pending';

  const getStatusConfig = () => {
    switch (actualStatus) {
      case 'matched':
        return {
          icon: CheckCircle,
          className: 'text-green-600',
          tooltip: 'הותאם',
        };
      case 'ignored':
        return {
          icon: Minus,
          className: 'text-gray-400',
          tooltip: 'לא דורש התאמה',
        };
      case 'pending':
      default:
        return {
          icon: Clock,
          className: 'text-orange-500',
          tooltip: 'ממתין להתאמה',
        };
    }
  };

  const config = getStatusConfig();
  const Icon = config.icon;

  return (
    <div className="flex items-center justify-center" title={config.tooltip}>
      <Icon className={`w-5 h-5 ${config.className}`} />
    </div>
  );
}
